import { InboxOutlined } from '@ant-design/icons';
import { Badge, List, Row, Space, Typography, theme } from 'antd';
import Link from 'next/link';
import { WsMessage } from '../../../clients/chat/types';
import { formatDate } from '../../TimeDisplay';
import { parseMediaMetaData } from './AgentChatComponent';

interface Props {
    data: { ticketKey: string; message: WsMessage }[];
    onMessageClick: (ticketKey: string) => void;
}

function getFileNameOrTextMessage(messageText: string) {
    const mediaMetaData = parseMediaMetaData(messageText);

    if (typeof mediaMetaData === 'object') {
        messageText = mediaMetaData.fileName;
    }
    return messageText;
}

export default function MessageList({ data, onMessageClick }: Props) {
    const {
        token: { colorSuccess, fontSizeXL, fontSizeHeading2 }
    } = theme.useToken();
    return (
        <List
            itemLayout="vertical"
            size="small"
            style={{ maxHeight: 500, overflowY: 'auto' }}
            dataSource={data}
            renderItem={(item) => {
                return (
                    <List.Item onClick={() => onMessageClick(item.ticketKey)} style={{ paddingBottom: 0 }}>
                        <List.Item.Meta
                            style={{ marginBlockEnd: 0 }}
                            avatar={
                                <Space align="center" direction="vertical" size={0}>
                                    <Badge dot status="success" offset={[-4, fontSizeHeading2 - 4]}>
                                        <InboxOutlined style={{ color: colorSuccess, fontSize: fontSizeHeading2 }} />
                                    </Badge>
                                    <Link href={`/tickets/${item.ticketKey}`} key={item.ticketKey}>
                                        See
                                    </Link>
                                </Space>
                            }
                            description={
                                <Typography.Paragraph ellipsis>
                                    {getFileNameOrTextMessage(item.message.text)}
                                </Typography.Paragraph>
                            }
                            title={
                                <Row justify="space-between" align="middle">
                                    {item.message.sender}
                                    <Typography.Text
                                        type="secondary"
                                        style={{ fontSize: fontSizeXL / 2, fontWeight: 'normal' }}
                                    >
                                        {formatDate(item.message.sentAt, { fromNow: true })}
                                    </Typography.Text>
                                </Row>
                            }
                        />
                    </List.Item>
                );
            }}
        />
    );
}

export { getFileNameOrTextMessage };
